import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadGrowthhack'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UI/UX 顧客体験 OOUI ユーザーリサーチ ペルソナ カスタマージャーニーマップ'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/growthhack/'}
        title="サイト改善ソリューション | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="i3DESIGN（アイスリーデザイン）が提供するサイト改善ソリューションで実施するプランの詳細を掲載しております。サイト分析手法（Google Analytics分析、ヒューリスティック分析、ユーザーテストなど）や施策実施について掲載しております。"
      />
      <Template />
    </>
  )
}

export default Download
